import axiosInstance from '@/api/axiosInstance';
import { FetchQuizzesParams, FetchQuizzesResponse } from './types';

/**
 * Fetch quizzes with pagination and filtering
 * GET /api/learning-center/quizzes
 */
export const fetchQuizzes = async (
  params?: FetchQuizzesParams
): Promise<FetchQuizzesResponse> => {
  try {
    const response = await axiosInstance.get<FetchQuizzesResponse>(
      '/api/learning-center/quizzes',
      { params }
    );
    return response.data;
  } catch (error) {
    console.error('Error fetching quizzes:', error);
    throw error;
  }
};
